export default [
    {
        path: '/user-permission',
        name: 'user_permission',
        component: () => import('@/views/apps/user_permission/UserPermission.vue'),
        children:[
            {
                path: '/user-permission/model',
                name: 'user_permission-model',
                component: () => import('@/views/apps/user_permission/model/Model.vue'),
                meta: {
                    action: 'read',
                    resource: 'userpermission',
                    pageTitle: 'Разрешения',
                    breadcrumb: [
                        {
                            text: 'Разрешения',
                        },
                        {
                            text: 'По сущностям',
                            active: true,
                        },
                    ],
                },
            },
            {
                path: '/user-permission/object',
                name: 'user_permission-object',
                component: () => import('@/views/apps/user_permission/object/Object.vue'),
                meta: {
                    action: 'read',
                    resource: 'userobjectpermission',
                    pageTitle: 'Разрешения',
                    breadcrumb: [

                        {
                            text: 'Разрешения',
                        },
                        {
                            text: 'По обьектам',
                            active: true,
                        },
                    ],
                },
           },
        ]
   },

]
